import { ZABBIX_URL } from "../constants";
import { apiSlice } from "./apiSlice";



export const zabbixApiSlice = apiSlice.injectEndpoints({
    endpoints: (builder) => ({
        getProblems: builder.query({
            query: () => ({
                url: `${ZABBIX_URL}/problems`,
            }),
            keepUnusedDataFor:5,
        }),
        updateProblem: builder.mutation({
            query: (data) => ({
                url: `${ZABBIX_URL}/problems`,
                method: 'POST',
                body: data,
            }),
        }),
    })
});

export const {useGetProblemsQuery, useUpdateProblemMutation} = zabbixApiSlice;